import type { RootState } from '@core/core/store'
import { createSelector } from '@reduxjs/toolkit'

import type { CubeBriefInfo, FieldId, SelectItem, Survey2dInfo } from '../../types'
import { selectAllProjectsRaw } from '../projects'
import { selectAllSurvey2ds } from '../surveys2ds'

export const selectActiveProject = (state: RootState) => state.project

export const selectActiveProjectId = (state: RootState) => selectActiveProject(state).id

export const selectProjectCubes = createSelector(
  [selectActiveProject],
  (activeProject): CubeBriefInfo[] => {
    return activeProject.cubes
  },
)

export const selectActiveProjectName = createSelector(
  [selectActiveProject, selectAllProjectsRaw],
  (activeProject, allProjects) => {
    return allProjects.find(project => project.id === activeProject.id)?.name
  },
)

export const selectProjectSurveys = createSelector(
  [selectAllSurvey2ds, selectActiveProject],
  (allSurveys, activeProject): Survey2dInfo[] => {
    return allSurveys.filter(cube => activeProject.surveys2ds.includes(cube.id))
  },
)

export const selectProjectFields = (state: RootState) => selectActiveProject(state).fields

export const selectProjectFieldsAsSelectItems = createSelector([selectProjectFields], fields =>
  fields.map<SelectItem<FieldId>>(({ id: key, name: label }) => ({
    key,
    label,
  })),
)
